var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","clip-rule":"evenodd","d":"M12.5 11.625L9 7.249 10.562 6l4.5 5.625-4.5 5.624L9 16l3.5-4.375z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }